<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-04-21 15:45:00
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-07-07 14:44:52
 * @FilePath: \watherfocast2\src\views\Login.vue
 * @Description: 登录页面
-->
<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <i class="el-icon-s-data login-icon"></i>
        <h2 class="login-title">海陆多场景集群风电精细化功率预报平台</h2>
        <p class="login-subtitle">Wind Power Prediction Platform</p>
      </div>
      
      <el-form 
        :model="loginForm" 
        :rules="loginRules" 
        ref="loginForm" 
        class="login-form"
        @keyup.enter.native="handleLogin"
      >
        <el-form-item prop="username">
          <el-input 
            v-model="loginForm.username" 
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            size="large"
          ></el-input>
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            type="password" 
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="large"
            show-password
          ></el-input>
        </el-form-item>
        
        <el-form-item class="remember-item">
          <el-checkbox v-model="loginForm.remember">记住密码</el-checkbox>
        </el-form-item>
        
        <el-form-item>
          <el-button 
            type="primary" 
            size="large" 
            class="login-btn"
            :loading="loading"
            @click="handleLogin"
          >
            登 录
          </el-button>
        </el-form-item>
      </el-form>
      
      <div class="login-footer">
        <p>© 2026 海陆多场景集群风电精细化功率预报平台 版权所有</p>
      </div>
    </div>
    
    <div class="login-bg">
      <div class="bg-animation"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: '',
        remember: false
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.checkRememberedUser()
  },
  methods: {
    checkRememberedUser() {
      const rememberedUser = localStorage.getItem('rememberedUser')
      if (rememberedUser) {
        const user = JSON.parse(rememberedUser)
        this.loginForm.username = user.username
        this.loginForm.password = user.password
        this.loginForm.remember = true
      }
    },

    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true

          axios.post('https://moodsci.com/lsserver/wind/user/login', {
            userName: this.loginForm.username,
            password: this.loginForm.password
          }).then(res => {
            if (res.data && res.data.code === '200') {
              const userData = res.data.data

              if (this.loginForm.remember) {
                localStorage.setItem('rememberedUser', JSON.stringify({
                  username: this.loginForm.username,
                  password: this.loginForm.password
                }))
              } else {
                localStorage.removeItem('rememberedUser')
              }

              localStorage.setItem('isLoggedIn', 'true')
              localStorage.setItem('username', userData.userName)
              localStorage.setItem('userId', userData.id)
              localStorage.setItem('stationId', userData.find)
              localStorage.setItem('hyStation', userData.hyStation || '')

              this.$message.success('登录成功')
              this.$router.push('/')
            } else {
              this.$message.error((res.data && res.data.msg) || '登录失败')
            }
          }).catch(err => {
            console.error('登录失败:', err)
            this.$message.error('登录失败，请检查网络或用户名密码')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0F1F39 0%, #1a3a5c 50%, #0F1F39 100%);
  z-index: -1;
}

.bg-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 20% 50%, rgba(0, 216, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(0, 216, 255, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 40% 20%, rgba(255, 170, 0, 0.05) 0%, transparent 50%);
  animation: bgMove 20s ease-in-out infinite;
}

@keyframes bgMove {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
}

.login-box {
  width: 420px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  z-index: 1;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-icon {
  font-size: 48px;
  color: #00d8ff;
  margin-bottom: 15px;
}

.login-title {
  font-size: 22px;
  font-weight: 600;
  color: #0F1F39;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.login-subtitle {
  font-size: 12px;
  color: #909399;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.login-form {
  margin-top: 20px;
}

.captcha-item {
  margin-bottom: 15px;
}

.captcha-box {
  display: flex;
  gap: 10px;
}

.captcha-input {
  flex: 1;
}

.captcha-img {
  width: 100px;
  height: 40px;
  background: linear-gradient(135deg, #0F1F39 0%, #1a3a5c 100%);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s;
}

.captcha-img:hover {
  opacity: 0.9;
  transform: scale(1.02);
}

.captcha-img span {
  font-size: 18px;
  font-weight: bold;
  color: #00d8ff;
  letter-spacing: 4px;
  font-family: 'Courier New', monospace;
}

.remember-item {
  margin-bottom: 20px;
}

.login-btn {
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 4px;
  background: linear-gradient(135deg, #0F1F39 0%, #1a3a5c 100%);
  border: none;
  transition: all 0.3s;
}

.login-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(15, 31, 57, 0.4);
}

.login-footer {
  margin-top: 30px;
  text-align: center;
}

.login-footer p {
  font-size: 12px;
  color: #909399;
}

/* 输入框样式调整 */
.login-form >>> .el-input__inner {
  border-radius: 4px;
  border-color: #dcdfe6;
}

.login-form >>> .el-input__inner:focus {
  border-color: #0F1F39;
}

.login-form >>> .el-input__prefix {
  color: #909399;
}
</style>
